import { Spinner } from "../../../Components/LoadingAnimations/LoadingAnimations";
import { cn } from "../../../utils/cn";
import { Button } from "../button";
import "./form.css";

type FormProps = {
  children: React.ReactNode;
  onSubmit: (e: React.SubmitEvent) => void;
  cancel?: () => void;
  className?: string;
  submitLabel?: string;
  cancelLabel?: string;
  isLoading?: boolean;
};

const Form = ({
  children,
  className,
  onSubmit,
  cancel,
  submitLabel,
  cancelLabel,
  isLoading,
}: FormProps) => {
  return (
    <form className={cn("custom__form", className)} onSubmit={onSubmit}>
      {children}
      <div className="full-cont">
        {isLoading ? (
          <Spinner />
        ) : (
          <div className="flex-1">
            <Button
              className="custom__form__button"
              type="submit"
              labelKey={submitLabel || "submit"}
              variant="primary"
            />
            {cancel && (
              <Button
                className="custom__form__button"
                type="reset"
                labelKey={cancelLabel || "cancel"}
                variant="secondary"
                onClick={cancel}
              />
            )}
          </div>
        )}
      </div>
    </form>
  );
};

export { Form };
